/* globals $, leaderboardData, queryString */
/* eslint-disable import/no-extraneous-dependencies, no-new */
import React from 'react'
import ReactDOM from 'react-dom'

import cloneDeep from 'lodash/cloneDeep'

import Visual from 'bam-node-evp/dist/Visual'

import schemaDefault from 'bam-node-evp/schema/default'

import Table from 'bam-node-savant-table/table'
import 'bam-node-evp/dist/styles.css'

let ticking = false
let isFixedHeaderShowing = false
const tableDivId = 'spinAxis'

$(() => {
    $('#btnUpdate').click(() => {
        window.location.href = populateUrl()
    })

    $('#btnCSV').click(() => {
        window.location.href = `/leaderboard/spin-direction-comparison?year=${$(
            '#ddlSeason'
        ).val()}&type=${$('#ddlType').val()}&min=${$('#ddlMin').val()}&team=${$(
            '#ddlTeamId'
        ).val()}&pov=${$('#ddlPOV').val()}&csv=true`
    })
})

$(document).ready(() => {
    $('form').submit(false)
    $('#ddlPitchTypeA').change(() => {
        $('#lblPitchTypeA').html($('#ddlPitchTypeA option:selected').text())
    })
    $('#ddlPitchTypeB').change(() => {
        $('#lblPitchTypeB').html($('#ddlPitchTypeB option:selected').text())
    })

    $('#ddlTeamId').change(() => {
        $('#lblTeamId').html($('#ddlTeamId option:selected').text())
    })
    $('#ddlPOV').change(() => {
        $('#lblPOV').html($('#ddlPOV option:selected').text())
    })

    $('#ddlSeason').change(() => {
        $('#lblSeason').html($('#ddlSeason').val())
    })

    $('#ddlMin').change(() => {
        $('#lblMin').html(
            `Min Pitches (${$('#ddlMin option:selected').text()})`
        )
    })

    $('#ddlType').change(() => {
        $('#lblType').html($('#ddlType option:selected').text())
    })

    if (queryString.min) {
        $('#ddlMin').val(queryString.min).attr('selected', true)
        $('#lblMin').html(
            `Min Pitches (${$('#ddlMin option:selected').text()})`
        )
    }

    if (queryString.pitchTypeA) {
        $('#ddlPitchTypeA').val(queryString.pitchTypeA).attr('selected', true)
        $('#lblPitchTypeA').html($('#ddlPitchTypeA option:selected').text())
    }
    if (queryString.pitchTypeB) {
        $('#ddlPitchTypeB').val(queryString.pitchTypeB).attr('selected', true)
        $('#lblPitchTypeB').html($('#ddlPitchTypeB option:selected').text())
    }

    if (queryString.year) {
        $('#ddlSeason').val(queryString.year).attr('selected', true)
        $('#lblSeason').html($('#ddlSeason').val())
    }

    if (queryString.team) {
        $('#ddlTeamId').val(queryString.team).attr('selected', true)
        $('#lblTeamId').html($('#ddlTeamId option:selected').text())
    }
    if (queryString.pov) {
        $('#ddlPOV').val(queryString.pov).attr('selected', true)
        $('#lblPOV').html($('#ddlPOV option:selected').text())
    }

    if (queryString.sortDir) {
        $('#sortDir').val(queryString.sortDir)
    }

    if (queryString.sort) {
        $('#sort').val(queryString.sort)
    }

    if (leaderboardData && leaderboardData.length > 0) {
        const secondaryHeaders = [
            {
                name: '',
                colspan: 4,
                headerClass: 'th-name-header',
            },
            {
                name: leaderboardData[0].pitch_name_a,
                colspan: 4,
                headerClass: 'th-title-header',
            },
            {
                name: leaderboardData[0].pitch_name_b,
                colspan: 4,
                headerClass: 'th-title-header',
            },
            {
                name: '',
                colspan: 1,
                headerClass: 'th-title-header',
            },
            {
                name: '',
                colspan: 1,
                headerClass: 'th-title-header',
            },
            {
                name: '',
                colspan: 1,
                headerClass: 'th-title-header',
            },
        ]

        const headers = [
            {
                name: 'Pitcher',
                field: 'href',
                headerClass:
                    'th-component-header align-left table-static-column',
                fieldClass: 'tr-data align-left table-static-column',
                photo: '<img class="player-mug" onError="this.onerror=null;this.src=\'https://content.mlb.com/images/headshots/current/60x60/generic.png\';" src="https://content.mlb.com/images/headshots/current/60x60/{1}.png">',
                photoId: 'player_id',
            },
            {
                name: 'Throws',
                field: 'pitch_hand',
                headerClass: 'th-component-header align-center',
                fieldClass: 'tr-data align-center',
            },
            {
                name: 'Total Pitches',
                field: 'n_pitches',
                type: 'number',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
            },
            {
                name: 'Pitches',
                field: 'n_pitch_a',
                type: 'number',
                headerClass: 'th-component-header border-left',
                fieldClass: 'tr-data border-left',
            },
            {
                name: 'Active Spin %',
                field: 'pitch_a_active_spin_formatted',
                type: 'number',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
            },
            {
                name: 'Spin-Based',
                field: 'pitch_a_hawkeye_measured_clock_label',
                customSortField: 'pitch_a_hawkeye_measured_clock',
                type: 'number',
                headerClass: 'th-component-header ',
                fieldClass: 'tr-data ',
            },
            {
                name: 'Observed',
                field: 'pitch_a_movement_inferred_clock_label',
                customSortField: 'pitch_a_movement_inferred_clock',
                type: 'number',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
            },
            {
                name: 'Pitches',
                field: 'n_pitch_b',
                type: 'number',
                headerClass: 'th-component-header border-left',
                fieldClass: 'tr-data border-left',
            },
            {
                name: 'Active Spin %',
                field: 'pitch_b_active_spin_formatted',
                type: 'number',
                headerClass: 'th-component-header ',
                fieldClass: 'tr-data',
            },
            {
                name: 'Spin-Based',
                field: 'pitch_b_hawkeye_measured_clock_label',
                customSortField: 'pitch_b_hawkeye_measured_clock',
                type: 'number',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
            },
            {
                name: 'Observed',
                field: 'pitch_b_movement_inferred_clock_label',
                customSortField: 'pitch_b_movement_inferred_clock',
                type: 'number',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
            },
            {
                name: 'Gap',
                field: 'diff_clock_label',
                customSortField: 'diff_measured_hours',
                type: 'number',
                headerClass: 'th-component-header border-top border-left ',
                fieldClass: 'tr-data border-left',
            },
            {
                name: 'Spin-Based',
                field: 'svgMeasured',
                headerClass: 'th-component-header border-left border-right',
                fieldClass: 'tr-data  border-left border-right',
            },
            {
                name: 'Observed',
                field: 'svgInferred',
                headerClass: 'th-component-header border-left border-right',
                fieldClass: 'tr-data border-left border-right',
            },
        ]

        const width = $(`#${tableDivId}`).outerWidth()
        let repeatHeaders = false
        if (width <= 768) {
            repeatHeaders = 15
        }

        new Table({
            id: tableDivId,
            repeatHeader: repeatHeaders,
            secondaryHeaders,
            headers,
            defaultSort:
                headers[Number($('#sort').val())].customSortField ||
                headers[Number($('#sort').val())].field,
            defaultSortDirection: $('#sortDir').val(),
            sortClass: 'column-sort',
            // PASS IN UNIQUE ROW ID... Use this for ajax calls
            subDataId: 'player_id',
            showRank: true,
            data: leaderboardData,
        })
    }

    $(`#${tableDivId}`).on(
        'click',
        '.default-table-row',
        function rowClickHandler() {
            const playerId = this.id.split('_')[1]
            if ($(`#${tableDivId}-trSub_${playerId}`).is(':visible') === true) {
                $(`#${tableDivId}-trSub_${playerId}`).hide()
            } else {
                $.ajax({
                    method: 'GET',
                    url: '/savant/api/v1/spin-direction-by-pitcher',
                    data: {
                        pitcher: playerId,
                        year: $('#ddlSeason').val(),
                        pov: $('#ddlPOV').val(),
                    },
                }).done((json) => {
                    const schema = cloneDeep(schemaDefault)

                    $(`#${tableDivId}-tdSub_${playerId}`).html(
                        `
                    <div>
                        <div style="display: inline-block;" id="data_meas_${playerId}"></div>
                        <div style="display: inline-block;" id="data_infer_${playerId}"></div>
                    </div>
                    `
                    )
                    $(`#${tableDivId}-trSub_${playerId}`).show()

                    const iData = []
                    for (let i = 0; i < json.length; i++) {
                        const d = json[i]
                        d.x = String(d.rn_clock)
                        d.y = d.infer_n_pitches
                        iData.push(d)
                    }

                    schema.charts = [
                        {
                            chartType: 'pitch',
                            overlayType: 'spinAxis',
                            legendType: 'pitchName',
                            showPlate: false,
                            legend: true,
                        },
                    ]
                    schema.sourcePlate.siteTitle = `SPIN DIRECTION - ${$(
                        '#ddlPOV option:selected'
                    )
                        .text()
                        .toUpperCase()}`
                    schema.sourcePlate.sourceTitle = 'promo'

                    schema.namePlate.photoId = playerId
                    schema.namePlate.primaryTitleText =
                        json[0].player_name_last_first
                    schema.namePlate.secondaryTitleFontSize = '.85rem'

                    schema.namePlate.secondaryTitleText =
                        'Observed Total Movement by Pitch Type'
                    schema.namePlate.secondaryFontColor = '#b00'

                    ReactDOM.render(
                        <Visual data={iData} chart={schema} />,
                        document.getElementById(`data_infer_${playerId}`)
                    )

                    const mData = []
                    for (let i = 0; i < json.length; i++) {
                        const d = json[i]
                        d.x = String(d.rn_clock)
                        d.y = d.meas_n_pitches
                        mData.push(d)
                    }

                    schema.charts[0].pitchTypes = [
                        'meas_n_ff',
                        'meas_n_si',
                        'meas_n_fc',
                        'meas_n_ch',
                        'meas_n_sl',
                        'meas_n_cu',
                        'meas_n_fs',
                        'meas_n_st',
                        'meas_n_sv',
                        'meas_n_sc',
                        'meas_n_fo',
                        'meas_n_kc',
                    ]

                    const mSchema = cloneDeep(schema)
                    mSchema.namePlate.secondaryTitleText =
                        'Spin-Based Movement by Pitch Type'

                    ReactDOM.render(
                        <Visual data={mData} chart={mSchema} />,
                        document.getElementById(`data_meas_${playerId}`)
                    )
                })
            }
        }
    )

    window.addEventListener('scroll', () => {
        if (!ticking && leaderboardData.length) {
            window.requestAnimationFrame(() => {
                checkHeaderPosition(tableDivId)
                ticking = false
            })

            ticking = true
        }
    })

    function checkHeaderPosition(divId) {
        const scrollPosY = window.scrollY
        const posTop = $(`#${divId}`).offset().top
        const height = $(`#${divId} table thead`).height()
        if (!isFixedHeaderShowing && posTop < scrollPosY) {
            isFixedHeaderShowing = true
            addStaticHeader(divId)
        } else if (isFixedHeaderShowing && posTop - height > scrollPosY) {
            $(`#${divId} table thead`).removeClass('fixed-header')
            isFixedHeaderShowing = false
        }
    }

    function addStaticHeader(divId) {
        const width = $(`#${divId}`).outerWidth()
        // $(".tr-component-row th").removeClass("column-sort");

        if (width && width > 767) {
            // console.log(width);
            let tableCell = 0

            // Set TH Width before applying fixed-header
            $(`#${divId} table .default-table-row`)
                .first()
                .children('td')
                .each(function rowEachHandler() {
                    const rowWidth = $(this).outerWidth()
                    $(
                        `#${divId} table .tr-component-row th:nth-child(${
                            tableCell + 1
                        })`
                    ).css('width', rowWidth)
                    tableCell += 1
                })

            $(`#${divId} table thead`).first().addClass('fixed-header')
            tableCell = 0

            // Set TD Width before applying fixed-header
            $(`#${divId} table .tr-component-row`)
                .children('th')
                .each(function rowEachHandler() {
                    const rowWidth = $(this).outerWidth()
                    $(
                        `#${divId} table .default-table-row td:nth-child(${
                            tableCell + 1
                        })`
                    ).css('width', rowWidth)
                    tableCell += 1
                })
        }
    }

    window.addEventListener('resize', () => {
        if (isFixedHeaderShowing) {
            addStaticHeader(tableDivId)
        }
    })

    $(document).on(
        'click',
        'th.th-component-header',
        function headerClickHandler() {
            const id = this.id.split('-')[1]

            if (Number($('#sort').val()) === Number(id)) {
                if ($('#sortDir').val() === 'desc') {
                    $('#sortDir').val('asc')
                } else {
                    $('#sortDir').val('desc')
                }
            } else {
                $('#sortDir').val('desc')
            }
            $('#sort').val(id)
            isFixedHeaderShowing = false
            checkHeaderPosition(tableDivId)
            populateUrl()
        }
    )
})

function populateUrl() {
    const pitchTypeA = $('#ddlPitchTypeA').val()
    const pitchTypeB = $('#ddlPitchTypeB').val()

    const year = $('#ddlSeason').val()
    const min = $('#ddlMin').val()
    const team = $('#ddlTeamId').val()
    const sort = $('#sort').val()
    const sortDir = $('#sortDir').val()
    const pov = $('#ddlPOV').val()

    const parameters = {
        pitchTypeA,
        pitchTypeB,
        min,
        pov,
        sort,
        sortDir,
        team,
        year,
    }

    const urlParams = new URLSearchParams(parameters)

    const url = `/leaderboard/spin-direction-comparison?${urlParams.toString()}`
    window.history.pushState('', '', url)
    return url
}
